const GENERATED_BATCH_PREFIX = "cit";

let generatedBatchPrefixOverride: string | null = null;

export function setGeneratedBatchPrefix(prefix: string | null): void {
  generatedBatchPrefixOverride = prefix;
}

function getGeneratedBatchPrefix(): string {
  return generatedBatchPrefixOverride ?? GENERATED_BATCH_PREFIX;
}

export function buildGeneratedBatchNumber(productNumber: string, controlNumber: number): string {
  return `${getGeneratedBatchPrefix()}-${productNumber}-${String(controlNumber).padStart(4, "0")}`;
}

export function parseGeneratedBatchNumber(batchNumber: string, productNumber: string): number | null {
  const pattern = new RegExp(`^${getGeneratedBatchPrefix()}-${escapeRegExp(productNumber)}-(\\d{4})$`, "i");
  const match = batchNumber.match(pattern);
  if (!match) return null;

  const parsed = Number(match[1]);
  return Number.isFinite(parsed) ? parsed : null;
}

export function getNextGeneratedBatchControlNumber(productNumber: string, existingBatchNumbers: Array<string | null | undefined>): number {
  let maxControlNumber = 0;

  for (const batchNumber of existingBatchNumbers) {
    if (!batchNumber) continue;
    const controlNumber = parseGeneratedBatchNumber(batchNumber, productNumber);
    if (controlNumber && controlNumber > maxControlNumber) {
      maxControlNumber = controlNumber;
    }
  }

  return maxControlNumber + 1;
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

const BATCH_OR_PRODUCT_NUMBER_PATTERN = /^[A-Z0-9-]*$/i;

export function isValidBatchOrProductNumberChars(value: string): boolean {
  return BATCH_OR_PRODUCT_NUMBER_PATTERN.test(value);
}
